// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C2Ma","footer":"styles_footer__ATV6X","passCodeTooltip":"styles_passCodeTooltip__1A0gt"};